/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

	$(document).ready(function() {		
		moscow.init();
    });

	moscow = {
      
      	init: function() {
        
        this.resize_function();
        this.Tools();
        this.responsive_function();
        this.wishlist();  
        this.tab();
        
        this.initAddToCart();
        
        this.initWishlist();
        
        this.sidebar_scroll();
        
        this.grid_height();
        this.page_load();
        
        this.fancybox();
        
        this.section_script();
	
      },
      
      	section_script: function(){
          var sections = new theme.Sections();
          sections.register('slideshow-section', moscow.main_slider);
          sections.register('collection-list', moscow.home_collection);
          sections.register('collections-template', moscow.collections);
          sections.register('collection-template', moscow.collection);
          sections.register('product-template', moscow.product);
          sections.register('contact-template', moscow.contact);
          sections.register('cart-section', moscow.cart_page);
          sections.register('search-template', moscow.search);
          sections.register('featured-collection', moscow.featured_collection);
		  sections.register('top-header',moscow.quickcart);	          
        },
      
      
      
      	
        featured_collection: function(){
            moscow.grid_height();
            moscow.pro_qty();
              
        	jQuery('.swatch :radio').change(function() {
              $('.compare_money').hide();
              $('.money_price').show();    
              var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
              var optionImage = jQuery(this).closest('.swatch li').data('image');
              //alert(optionImage);
              var optionValue = jQuery(this).val();
              jQuery(this)
              .closest('form')
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
              jQuery(this).closest('form').parent().parent().find('.image_hvr img').attr('src', optionImage );
            });
          
          
          
          
        },
      
        search:function(){
        	$('.second_row .grid__item .slide').responsiveEqualHeightGrid(); 
			moscow.pro_qty();
        },
      
        cart_page : function(){
        	moscow.pro_qty();
		},
      
        current_variant_image : function(){
            $(window).load(function(){
              var variant_src = $('#ProductPhotoImg').attr('src');
              if(variant_src){
                var source = variant_src.replace('https:','');
                $('#slider_pager a img').each(function(){
                  var data = $(this).attr('src');

                  if( source == data ){
                    $(this)[0].click();
                  }

                });
               
              }

            }); 

        },
      
         quickview_current_variant_image : function(){
           
              var variant_src = $('#ProductPhotoImg').attr('src');
              if(variant_src){
                var source = variant_src.replace('https:','');
                $('#thumb_pager a img').each(function(){
                  var data = $(this).attr('src');

                  if( source == data ){
                    $(this)[0].click();
                  }

                });
               
              }
	     },
      
      
      	home_collection: function(){
      		$('.second_row .grid__item .slide').responsiveEqualHeightGrid(); 
        },
        
      	collections:function(){
        	new AnimOnScroll( document.getElementById( 'lookbook_grid' ), {
              minDuration : 0.4,
              maxDuration : 0.7,
              viewportFactor : 0.3,
              columnWidth: 200
            });
        },
        
      	collection: function(container){
           var $container = this.$container = $(container);
          
          if($container.attr('data-filter') == 'true'){
          	 moscow.initSidebar();
          }
			moscow.sidebarMapPaging();
			moscow.sidebarParams();
			moscow.sidebarMapSorting();
			moscow.grid_height();
          
            moscow.filter_sorting();
          
            moscow.pro_qty();
            
            jQuery('.swatch :radio').change(function() {
              $('.compare_money').hide();
              $('.money_price').show();    
              var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
              var optionImage = jQuery(this).closest('.swatch li').data('image');
              //alert(optionImage);
              var optionValue = jQuery(this).val();
              jQuery(this)
              .closest('form')
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
              jQuery(this).closest('form').parent().parent().find('.image_hvr img').attr('src', optionImage );
            });
          
            //window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
         
        },
      
      	product: function(container){
          var $container = this.$container = $(container);
          var sectionId = $container.attr('data-section-id');
    
          if (!$('#ProductJson-' + sectionId).html()) {
            return;
          }
          var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
          new Shopify.OptionSelectors('productSelect', {
            product: productSingleObject,
            onVariantSelected: selectCallback,
            enableHistoryState: true
          });
          
          moscow.tab();
          moscow.product_slider();
          moscow.related_product();
          moscow.pro_qty();
          
          
          moscow.zoom_trigger();
          
          if($container.attr('data-review') == 'true'){
            //window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
          }
         
          
      	},
        
      	contact: function(container){
          var $container = this.$container = $(container);
          var map_address = $container.attr('data-address');
          var zoom_level = $container.attr('data-zoom');
          var scrollwheel = $container.attr('data-scroll');
           
          if(scrollwheel == 'false'){
              var boolen_scroll = false ;
          }else{
              var boolen_scroll = true ;
          }  
          
          var latlng = new google.maps.LatLng(0, 0);
          var myOptions = {
              zoom: parseInt(zoom_level),
              center: latlng,

              scrollwheel: boolen_scroll,
              scaleControl: true,
              disableDefaultUI: false,

              mapTypeId: google.maps.MapTypeId.ROADMAP,
               styles: [
                  {
                    featureType: 'all',
                    stylers: [
                        { hue: address},
                      { saturation: 50 }
                    ]
                  },{
                  featureType: 'road',
                  elementType: 'geometry',
                  stylers: [
                    { lightness: 100 },
                    { visibility: 'simplified' }
                  ]
                },{
                    featureType: 'poi.business',
                    elementType: 'labels',
                    stylers: [
                      { visibility: 'on' }
                    ]
                  }
                ]
            };
            var map2 = new google.maps.Map(document.getElementById("map-canvas"),
                                           myOptions);

            var geocoder_map2 = new google.maps.Geocoder();
            var address = map_address;
            geocoder_map2.geocode( { 'address': address}, function(results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                map2.setCenter(results[0].geometry.location);

                var marker = new google.maps.Marker({
                  map: map2, 

                  position: map2.getCenter()
                });

                var contentString = map_address;
                var infowindow = new google.maps.InfoWindow({
                  content: contentString
                });



              } else {
                alert("Geocode was not successful for the following reason: " + status);
              }
            });	
          
        },
      	
        fancybox: function(){          
            // Call Fancybox for product modal + stop scroll to top 
            $('.product-modal').fancybox({
              helpers: {
                overlay: {
                  locked: false
                }        
              }    
            });

            $('.product-modal').click(function(e){
              e.preventDefault();
            });
        },
      
     
      
        quickcart: function(){
          
          $('.bag_icon').click(function(e) {
            e.preventDefault();
            ajaxCart.load();
            $('.quick_cart').toggleClass('active_cart');
          });

          $('.close_cart').click(function(e) {
            $('.quick_cart').removeClass('active_cart');
          });
        },
      
        main_slider: function(container){
            var $container = this.$container = $(container);
            var id = $container.attr('data-section-id');
            var transition = $container.attr('data-transition');
            if($container.attr('data-autoplay') == 'true'){
              var autoplay = true;
            }
            else{
              var autoplay = false;
            }

            var speed = $container.attr('data-speed');

            if($container.attr('data-show-dots') == 'true'){
              var show_dots = true;
            }
            else{
              var show_dots = false;
            }

          
          if($container.attr('data-show-nav') == 'true'){
            var show_nav = true;
          }
          else{
            var show_nav = false;
          }
		
          
          var slideHeight = $(window).height() - $('.top_header').outerHeight();

          var slider = $('.'+ id + ' ul').bxSlider({
            mode: $container.attr('data-transition'),
            infiniteLoop: true,
            pager: show_dots,
            auto: autoplay,
            controls: show_nav,
            pause: $container.attr('data-speed')

          });

        },	
      
        sidebar_scroll: function(){
          $(".filter_sidebar .filter .sidebar-tag").niceScroll();
        },
      
        resize_function : function(){
          $(window).resize(function () {
            // ------------ Instagram images Height -------------
			$('.insta_listing .insta_item').css('height', $('.insta_item').width());
		  });

            // -------------------- Instagram carousel ---------------------

           if ($(window).width() <= 480) {
                $('.insta_listing').owlCarousel({
                  loop:true,
                  margin:0,
                  autoHeight : true,
                  responsiveClass:true,
                  responsive:{
                    0:{
                      items:3
                    },
                    767:{
                      items:3
                    }
                  }
                });
           }
      	},
      
        newslatter: function(){
          // ----------------- Newsletter -------------------

          $(window).load(function(){
            setTimeout( function() {
              var check_cookie = $.cookie('mailing_list_popup');


              $('.newsletter_content .close_popup').click(function(e) {
                $.cookie('mailing_list_popup', '1', { expires: 31 });
                $(".newsletter_full").removeClass('active_newsletter');
              });

              if(check_cookie == 1){
                $('.newsletter_full').hide();
              }
              if(check_cookie == null){
                $.cookie('mailing_list_popup', '1', { expires: 31 });
                $(".newsletter_full").addClass('active_newsletter');
              }
              else if(check_cookie < 1){

                x = $.cookie('mailing_list_popup');
                y = 1;
                var z = +x + +y;
                $.cookie('mailing_list_popup', z, { expires: 31 });
                $(".newsletter_full").addClass('active_newsletter');
              }
            }, 4000);
          }); 

        },
      
        grid_height: function(){	

          $('.grid__item .product_img').responsiveEqualHeightGrid();  
        },
      
        filter_sorting: function(){
          // -------------------- Filter Accordion ---------------------

          $('.filter h3').click(function(e) {
            $(this).parent().find('.sidebar-tag').slideToggle();
          });


          $('.filter_category h3').click(function(e) {
            $(this).parent().find('.sidebar-links').slideToggle();
          });
          // ------------ Filter Sorting ---------------

          $('.dropdown_btn').click(function(e) {
            $('.dropdown_menu').slideToggle(100);
          });

          $(document).click( function(e){
            $('.dropdown_menu').slideUp(100);
          });

          $('.dropdown_btn').click(function(e){
            e.preventDefault();
            $('ul.dropdown_menu').css('display', 'block');
            event.stopPropagation();
          });
          
          $('ul.dropdown_menu').css('display', 'none');
          
        },
      
        Tools: function(){

              // ------------ Search --------------

              $('.search_icon').click(function(e) {
                $('.top_header').toggleClass('search_active');
              });

              // -------------------- Quick Cart ---------------------

              $('.scrollToTop').click(function(){
                $('html, body').animate({scrollTop : 0},800);
                return false;
              });

              // ================= Go To Top ==========================

              //Check to see if the window is top if not then display button
              $(window).scroll(function(){
                if ($(this).scrollTop() > 100) {
                  $('.scrollToTop').fadeIn();
                } else {
                  $('.scrollToTop').fadeOut();
                }
              });


              

      },
      
        product_slider: function(){
        // -------------- Product Slider -----------------

        if($(window).width() <= 1024){

          $('.product_slider').bxSlider({
            mode: 'fade',
            controls: false,
            pager: true,
          });

          $('#slider_pager').bxSlider({
            mode:'vertical',
            controls: false,
            pager: false
          });


        }
        else{

          $('#product .product_slider').bxSlider({
            mode: 'fade',
            pagerCustom: '#slider_pager',
            controls: false
          });




          $('#product #slider_pager').bxSlider({
            mode: 'vertical',
            pager: false,
            controls: true,
            minSlides: 5,
            maxSlides: 5,
            slideWidth: 165,
            slideMargin: 20,
            nextText: '<i class="fa fa-angle-down"></i>',
            prevText: '<i class="fa fa-angle-up"></i>',
            infiniteLoop: false,
            hideControlOnEnd: true
          });

            

        }


	  },
      
        related_product : function(){


        if($(window).width() <= 480){
          $('.related_product .product_listing .grid').bxSlider({
            pager: true,
            controls: false,
            minSlides: 1,
            maxSlides: 1,
            slideWidth: 280,
            infiniteLoop: false,
          });

        }
        else if($(window).width() >= 481 && $(window).width() <= 767){
          $('.related_product .product_listing .grid').bxSlider({
            pager: true,
            controls: false,
            minSlides: 1,
            maxSlides: 2,
            slideWidth: 252,
            infiniteLoop: false,
          });

        } 
      },
      
        responsive_function : function(){
          // --------- RESPONSIVE MENU TRIGGER ------------

          $('.menu_icon').click(function(e) {
            $(this).toggleClass('active');
            $('#main-nav').toggleClass('menu-active');
            $('.right_content').toggleClass('opacity_full');
          });


          // -----------------------Fixed header

          // Hide Header on on scroll down
          var didScroll;
          var lastScrollTop = 0;
          var delta = 5;
          var navbarHeight = $('header').outerHeight();

          $(window).scroll(function(event){
            didScroll = true;
          });

          setInterval(function() {
            if (didScroll) {
              hasScrolled();
              didScroll = false;
            }
          }, 250);
          hasScrolled();

          function hasScrolled() {
            var st = $(this).scrollTop();

            if(Math.abs(lastScrollTop - st) <= delta)
              return;

            if($(window).width() <= 767){
              if (st > lastScrollTop && st > navbarHeight){
                $('.left_sidebar').removeClass('nav-down').addClass('nav-up');
              } else {
                if(st + $(window).height() < $(document).height()) {
                  if(st==0){
                    $('.left_sidebar').removeClass('nav-up').removeClass('nav-down');
                  }
                  else{
                    $('.left_sidebar').removeClass('nav-up').addClass('nav-down');
                  }
                }
              }
              lastScrollTop = st;
            }
          }



          // ---------- Mobile Search -------------

          $('.mob_search').click(function(e) {
            e.preventDefault();
            $('.search_dropdown').slideToggle();
            $('.right_content').toggleClass('opacity_full');
          });


          // -------------- Sidebar Toggle ----------------


          $('.sidebar_toggle a').click(function(e) {
            $('.filter_sidebar').addClass('active');
            $('body').addClass('main-overlay');
          });

          $('.close_sidebar').click(function(e){
            $('.filter_sidebar').removeClass('active');
            $('body').removeClass('main-overlay');
          });


          // -------------- 404 Page -----------------

          $('.error_section').css('height', $(window).height());
},

        wishlist: function(){

          if($(".wishlist-items .product-item").length == 0) {
            $("#share_via_mail").hide();
            $(".wishlist-header").hide();
            $(".empty_wishlist").show();  
            //$("#wishlist-email-link").empty().html("<p>Your wish list is currently empty.</p>");
          } else {
            $(".empty_wishlist").hide();
          }
          //wishlist ajax

},

        tab : function(){
          // --------- Product Tabs ------------

          $( "#accordion" ).accordion({
            heightStyle: "content",
            collapsible: true  
          });


          // ------------ FAQ tabs ------------

          $( "#tabs" ).tabs();
          $( "#faqtabs" ).tabs();
          //ajax-sucess --
          $('.ajax-success-modal .close-modal').click(function(){
            $('.ajax-success-modal').hide();

          });

          $('.ajax-success-modal .continue-shopping').click(function(){
            $('.ajax-success-modal').hide();

          });

},

        initSidebar: function() {
          //if category page then init sidebar
          if ($(".filter_sidebar").length > 0) {

            moscow.sidebarMapEvents();
            moscow.sidebarMapClear();
            moscow.sidebarMapClearAll();
          }
        
},	

        sidebarMapCategories: function() {
          $(".sidebar-links li a").click(function(e) {
            e.preventDefault();
            var currentTags = [];

            if (Shopify.queryParams.constraint) {
              delete Shopify.queryParams.constraint;
            }

            var collection_name =  $(this).attr('href');

            if(collection_name == 'all') {
              $(this).addClass('active');
              delete Shopify.queryParams.constraint;
            }else{
              if (collection_name) {
                var tagPos = currentTags.indexOf(collection_name);    

                if (tagPos >= 0) {
                  //tag already existed, remove tag
                  currentTags.splice(tagPos, 1);
                } else {
                  //tag not existed
                  currentTags.push(collection_name);
                }
              }

              if (currentTags.length) {
                Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                delete Shopify.queryParams.constraint;
              }

            }

            moscow.sidebarAjaxClick();
          });
},

        sidebarParams: function() {
          Shopify.queryParams = {};
          //get after ?...=> Object {q: "Acme"} 
          if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
              aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
            }
          }
},

        sidebarMapEvents: function() {
          moscow.sidebarMapTagEvents();
          moscow.sidebarMapCategories();

},

        sidebarMapTagEvents: function() {            
          $('.sidebar-tag a:not(".clear"), .sidebar-tag .row').click(function(e) {
            
            var currentTags = [];
            var check_radio =  $(this).prev().attr("type");
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            if(check_radio == "radio"){                 
              //one selection or multi selection                
              if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                //remove other selection first
                var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                if (otherTag.length > 0) {
                  var tagName = otherTag.val();
                 
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                      //remove tag
                      currentTags.splice(tagPos, 1);
                    }
                  }
                }
              }
            }

            var tagName = $(this).find('input').val();                

            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);                    
              if (tagPos >= 0) {
                //tag already existed, remove tag
                currentTags.splice(tagPos, 1);
              } else {
                //tag not existed
                currentTags.push(tagName);
              }
            }
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            moscow.sidebarAjaxClick();
            e.preventDefault();
          });
},

        sidebarMapSorting: function(e) {
          $(".sort_dropdown a").click(function(e) {
            if (!$(this).parent().hasClass("active")) {
              Shopify.queryParams.sort_by = $(this).attr("href");
              moscow.sidebarAjaxClick();
              var sortbyText = $(this).text();
              $(".sort_dropdown > button").html(sortbyText + '<span><i class="fa fa-angle-down" aria-hidden="true"></i></span>');
              $(".sort_dropdown li.active").removeClass("active");

              $(this).parent().addClass("active");
              $(".dropdown_menu").hide();

            }
            e.preventDefault();
          });
        },

        sidebarMapPaging: function() {

          $(".product_listing .pagination a").click(function(e) {
            var page = $(this).attr("href").match(/page=\d+/g);

            if(page) {

              Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));

              if (Shopify.queryParams.page) {
                var newurl = moscow.sidebarCreateUrl();

                moscow.isSidebarAjaxClick = true;
                History.pushState({
                  param: Shopify.queryParams
                }, newurl, newurl);
                moscow.sidebarGetContent(newurl);
                //go to top
                $('body,html').animate({
                  scrollTop: 500
                }, 600);
              }
            }
            e.preventDefault();
          });


},

        sidebarMapClearAll: function() {
          //clear all selection
          $('a.clear-all').click(function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;                
            moscow.sidebarAjaxClick();
            e.preventDefault();                
          });
},

        sidebarMapClear: function() {            
          $(".filter").each(function() {
            var sidebarTag = $(this);
            if(sidebarTag.find("input:checked").length > 0) {
              $('a.clear-all').css("display","inline-block");
              //has active tag
              sidebarTag.find(".clear").css("display","inline-block").click(function(e) {
                var currentTags = [];
                if(Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
                }
                sidebarTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if(tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                      //remove tag
                      currentTags.splice(tagPos, 1);
                    }
                  }
                });
                if(currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                  delete Shopify.queryParams.constraint;
                }
                moscow.sidebarAjaxClick();
                e.preventDefault();
              });
            }
          });
},

        sidebarCreateUrl: function(baseLink) {
          var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');

          if (baseLink) {
            //location.href = baseLink + "?" + newQuery;
            if (newQuery != "")
              return baseLink + "?" + newQuery;
            else
              return baseLink;
          }
          return location.pathname + "?" + newQuery;
},

        sidebarAjaxClick: function(baseLink) {

          delete Shopify.queryParams.page;
          var newurl = moscow.sidebarCreateUrl(baseLink);
		
          moscow.isSidebarAjaxClick = true;
          History.pushState({
            param: Shopify.queryParams
          }, newurl, newurl);
          moscow.sidebarGetContent(newurl);            
},

        sidebarGetContent: function(newurl) {
          $.ajax({
            type: 'get',
            url: newurl,
            beforeSend: function() {
              moscow.showLoading();
            },
            success: function(data) {
              $('body').removeClass('main-overlay');
              moscow.sidebarMapData(data);
              moscow.sidebarMapPaging();
              moscow.sidebarMapTagEvents();
              moscow.sidebarMapClear();
              moscow.sidebarMapClearAll();
              moscow.sidebarMapCategories();
              moscow.initAddToCart();
              $('.overlay_detail select').hide();
              moscow.quntity();
              moscow.hideLoading();

              moscow.createQuickViewVariantsSwatch();

              setTimeout(function() {
                moscow.grid_height();  
              }, 1000);
              moscow.initWishlist();
              moscow.sidebar_scroll();
           
              $('.filter h3').click(function(e) {
                $(this).parent().find('.sidebar-tag').slideToggle();
              });

                $('.sidebar_toggle a').click(function(e) {
                $('.filter_sidebar').addClass('active');
              });


              $('.filter_category h3').click(function(e) {
                $(this).parent().find('.sidebar-links').slideToggle();
              });

              $('.close_sidebar').click(function(e){
                $('.filter_sidebar').removeClass('active');
              });


              //moscow.sidebarStyle();                  
            },
            error: function(xhr, text) {
              moscow.hideLoading();
              $('.loading-modal').hide();
              $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
              moscow.showModal('.ajax-error-modal');
            }
          });
},

        sidebarMapData: function(data) {     

          var currentList = $(".product_listing");

          if (currentList.length == 0) {
            currentList = $(".product_listing");
          }

          var productList = $(data).find(".product_listing");

          if (productList.length == 0) {
            productList = $(data).find(".product_listing");
          }

          var blog_list = $(".blog_listing");	

          if (blog_list.length == 0) {
            blog_list = $(".product_listing");
          }

          var blog_productlist = $(data).find(".blog_listing"); 

          if (blog_productlist.length == 0) {
            blog_productlist = $(data).find(".product_listing");
          }

          currentList.replaceWith(productList);

          
          //replace paging 
          if ($(".pagination").length > 0) {
            $(".pagination").replaceWith($(data).find(".pagination"));
          }

          if ($(data).find(".page-total").length > 0) {
            $(".page-total").show();
            $(".page-total").replaceWith($(data).find(".page-total"));
          }else{
            $(".page-total").hide();
          }  
          //replace tags            
          $(".filter_sidebar").replaceWith($(data).find(".filter_sidebar"));       

          //open filter tab   

          //product review
          //window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

},

        showModal: function(selector) {
          $(selector).fadeIn(500)
          moscow.moscowTimeout = setTimeout(function() {
            $(selector).fadeOut(900);
          }, 5000);
},

        quntity: function(){

          $(".product_overlay .qty .qty_box .plus").click(function(e) {
            var getval = $(this).parents(".qty_box").find(".product-quantity").val();
            getval++;
            $(this).parents(".qty_box").find(".product-quantity").val(getval); 


          });

          $(".product_overlay .qty .qty_box .minus").each(function(index, element) {
            $(this).click(function(e) {
              var getval = $(this).parents(".qty_box").find(".product-quantity").val();
              if(getval > 1)
              {
                getval--;   
              }
              $(this).parents(".qty_box").find(".product-quantity").val(getval);
            });
          }); 

},

      	initAddToCart: function() {

        if ($('.add_cart_btn').length > 0) {
          $("body").on('click', '.add_cart_btn', function(event) {

            event.preventDefault();
            if ($(this).attr('disabled') != 'disabled') {
              var productItem = $(this).parents('.product_item');

              var productId = $(productItem).attr('id');

              productId = productId.match(/\d+/g);

              var variant_id = $('.product-actions-' + productId + ' select[name=id]').val();

              var quantity = $('.product-actions-' + productId + ' input[name=quantity]').val();
              if (!quantity) {
                quantity = 1;
              }
              var title = $(productItem).find('.product_desc a.pro_title').html();
            
              var image = $(productItem).find('.image_hvr img').attr('src');
              moscow.doAjaxAddToCart(variant_id, quantity, title, image,productId);

            }
            return false;
          });
        }

        $("body").on('click', '.submit_row .btn', function(event) {
          event.preventDefault();

          if ($(this).attr('disabled') != 'disabled') {

            var productItem = $(this).parents('.product_desc');

            var productId = $(productItem).data('id');

            var variant_id = $('.product-actions-' + productId + ' select[name=id]').val();

            var quantity = $('.product-actions-' + productId + ' input[name=quantity]').val();

            if (!quantity) {
              quantity = 1;
            }

            var title = $(productItem).find('h2').html();
           
            if($(window).width() > 1024){
            var image = $('#slider_pager a.active  img').attr('src');
            }else{
            var image = $('.product_slider li.active  img').attr('src');
            
            }
            moscow.doAjaxAddToCart(variant_id, quantity, title, image, productId);

          }
          return false;
        });

	  },
      
      	doAjaxAddToCart: function(variant_id, quantity, title, image, productId) {

        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: 'quantity=' + quantity + '&id=' + variant_id,
          dataType: 'json',
          beforeSend: function() {
            moscow.showLoading();
          },
          success: function(msg) {
			
             

            $('.ajax-success-modal').find('.ajax-product-title').html(title);
            $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
            $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
            $('.ajax-success-modal').find('.btn-go-to-cart').show();
            $('.ajax-success-modal').find('.error_color').hide();
            moscow.showModal('.ajax-success-modal');
            

            
            moscow.quickcart();
            moscow.hideLoading();
            moscow.updateDropdownCart();

          },
          error: function(XMLHttpRequest) {
            moscow.hideLoading();
            var response = eval('(' + XMLHttpRequest.responseText + ')');

            response = response.description;

            if (response.slice(0,4) === 'All ') {
              
               
              $('.ajax-success-modal').find('.ajax-product-title').html(title);
              $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
              $('.ajax-success-modal').find('.error_color').text(response).show();
              $('.ajax-success-modal').find('.success-message.btn-go-to-cart').hide();
              $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();

              moscow.showModal('.ajax-success-modal'); 
              

              


              $('.product-actions-'+productId).find('#AddToCart').addClass('disabled').attr('disabled', 'disabled').val('Sold out');

            }
            else {

              

               
              $('.ajax-success-modal').find('.ajax-product-title').html(title);
              $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
              $('.ajax-success-modal').find('.error_color').text(response).show();
              $('.ajax-success-modal').find('.success-message.btn-go-to-cart').hide();
              $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
              moscow.showModal('.ajax-success-modal'); 
              $('.product-actions-'+productId).find('#AddToCart').addClass('disabled').attr('disabled', 'disabled').val('Sold out');
              
            }
          }


        });
	  },
      
      	updateDropdownCart: function() {
        ShopifyAPI.getCart(function(cart) {
          moscow.doUpdateDropdownCart(cart);
        });
	  },
      
      	doUpdateDropdownCart: function(cart) {
        moscow.quickcart();  
        ajaxCart.load();

	  },

      	showLoading: function() {
        $('.loading-modal').show();
	  },
      
      	hideLoading: function() {
        $('.loading-modal').hide();
      },
      
      	createQuickViewVariantsSwatch: function() {

        $('.product_listing .product_item').each(function(index,element){
          var product_handle = $(this).data('handle');
          var index = index + 1;
          Shopify.getProduct(product_handle, function(product) {
            new Shopify.OptionSelectors("productSelect" + index, {
              product: product,
              onVariantSelected: selectCallback
            });
          });

        });

        jQuery('.swatch :radio').change(function() {
          var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          var optionImage = jQuery(this).closest('.swatch li').data('image');
          var optionValue = jQuery(this).val();
          jQuery(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
          jQuery(this).closest('form').parent().parent().find('.image_hvr img').attr('src', optionImage );

        });

	  },
      
      	initWishlist: function() {


        $('.product_item').each(function(){

          $(this).find('.wishlist_heart form button.wishlist_btn').click(function(e) {

            e.preventDefault();

            var form = $(this).parent();
            var item = form.closest('.grid__item');
            $.ajax({
              type: 'POST',
              url: '/contact',
              data: form.serialize(),
              beforeSend: function() {
                moscow.showLoading();
              },
              success: function(data) {
                //$('#messageBox').text('product added into Wishlist').fadeIn().delay(4000).fadeOut('slow'); 
                form.html('<a href="/pages/wishlist" id="add-new-wishlist" class="wishlist btn--primary btn--small fa fa-heart"></a>');

                var title = item.find('.product_desc a').text();
                var image = item.find('.image_hvr  img').attr('src');
                $('.ajax-success-modal').find('.ajax-product-title').html(title);
                $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                $('.ajax-success-modal').find('.error_color').hide();
                moscow.showModal('.ajax-success-modal');	
                moscow.hideLoading();
              },
              error: function(xhr, text) {
                moscow.hideLoading();
                $('.loading-modal').hide();
                $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                moscow.showModal('.ajax-error-modal');
              }
            });
          });

        });



        $('#product .product_desc .wishlist_heart form button.wishlist_btn').click(function(e) {

          e.preventDefault();
          var form = $(this).parent();
          var item = form.parents('.grid__item');
          $.ajax({
            type: 'POST',
            url: '/contact',
            data: form.serialize(),
            success: function(data) {
              // $('#messageBox').text('product added into Wishlist').fadeIn().delay(4000).fadeOut('slow'); 
              form.html('<a href="/pages/wishlist" id="add-new-wishlist" class="wishlist btn--primary btn--small fa fa-heart"></a> ');

              var title = item.find('.product-title').html();
              var image = item.find('.image_hvr  img').attr('src');
              $('.ajax-success-modal').find('.ajax-product-title').html(title);
              $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
              $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
              $('.ajax-success-modal').find('.btn-go-to-cart').hide();
              $('.ajax-success-modal').find('.error_color').hide();
              moscow.showModal('.ajax-success-modal');	


            },
            error: function(xhr, text) {
            }
          });
        });
	  },
      
      	page_load: function(){
        $(".animsition").animsition({
          inClass               :   'fade-in',
          outClass              :   'fade-out',
          inDuration            :    1000,
          outDuration           :    1000,
          // linkElement        :   '.animsition-link',
          linkElement			:   'a:not([target="_blank"]):not([href^="#"]):not([href^="javascript:void(0)"]):not([class*="no-redirect"]):not([class*="shopify-preview-bar__minimize"])',
          loading               :    true,
          loadingParentElement  :   'body', //animsition wrapper element
          loadingClass          :   'animsition-loading',
          onLoadEvent			: 	true,
          unSupportCss          : [ 'animation-duration',
                                   '-webkit-animation-duration',
                                   '-o-animation-duration'
                                  ],
          overlay               :   false,
          overlayClass          :   'animsition-overlay-slide',
          overlayParentElement  :   'body'
        });
        $(".animsition").on('animsition.inStart', function(){
          if($(window).width() > 1024){
              new WOW().init();
         }
       
        });
      },
      
      	pro_qty: function(){
          
        $('.plus').click(function(){
          var getval = $(this).parent().find('#quantity').val();
          getval++;
          $(this).parent().find('#quantity').val(getval);
          $('#update-cart').trigger('click');
        });	

        $('.minus').click(function(){
          var getval = $(this).parent().find('#quantity').val();

          if(getval > 1)
          {
            getval--;;
            $(this).parent().find('#quantity').val(getval);
          }
          else 
          {
            $(this).parent().find('#quantity').val(getval);
          }
          $('#update-cart').trigger('click');
        });

	  },
      
      	zoom_trigger: function(){

        var window_width = $( window ).width();
        if(window_width > 1024){

          $('.product_slider li').each(function(){

            var mainProductImage = $(this).find('img');
            if (mainProductImage.size()) {
              var zoomedSrc = mainProductImage.attr('src').replace('_1024x1024.', '.');
              mainProductImage
              .wrap('<span style="display:inline-block;max-width:100%"></span>')
              .css('display', 'block')
              .parent()
              .zoom( { url: zoomedSrc } );

            }



          }); 

        }


        $(window).load(function(){

          $('.product_slider li').not($('.product_slider li:first')).each(function(index, element) {
            var get_img_src = $('span img:first',this).attr('src');
            $('span img:last',this).attr('src',get_img_src);
          });

        });

      },
       
}		
        

    
  